import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconSearchProps extends SVGProps<any> {}
export class SVGIconArrowRightDuplo extends Component<SVGIconSearchProps> {
  render() {
    const { width = 14, height = 13, color = '#11465D', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 14 13`}
        fill={color}
        {...rest}
      >
        <g>
          <path
            d="M13.4264 5.12964L8.24315 0L6.86035 1.37036L12.0436 6.5L6.86035 11.6296L8.24707 13L13.4264 7.87036C13.7939 7.50688 14.0003 7.01396 14.0003 6.5C14.0003 5.98604 13.7939 5.49312 13.4264 5.12964Z"
            fill={color}
          />
          <path
            d="M7.26285 5.81482L1.38279 0L0 1.37036L5.18327 6.5L0 11.6296L1.38671 13L7.26677 7.18518C7.44998 7.00293 7.55248 6.75618 7.55175 6.4992C7.55101 6.24222 7.4471 5.99605 7.26285 5.81482Z"
            fill={color}
          />
        </g>
      </SVG>
    );
  }
}
